export default class MasterPreAssessmentList {
    constructor({ assessmentId: id, assessmentCode: code, meetingSchedule: schedule, meetingLink: link, asesiName: asesiName, assessorName: assessorName, schemeTitle: scheme, testPlaceName: place }) {
        this.assessmentId = id;
        this.assessmentCode = code;
        this.meetingSchedule = schedule;
        this.meetingLink = link;
        this.asesiName = asesiName;
        this.assessorName = assessorName;
        this.schemeTitle = scheme;
        this.testPlaceName = place;
    }
}
